import { makeStyles } from '@material-ui/core/styles';
import { secondaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { colors, spacing, radius, breakpoints, sizes, fonts, fontSize } = redesignTheme;

export const useProfileSummaryCardStyles = makeStyles(() => ({
  summaryCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    width: '100%',
    padding: spacing.md,
    borderRadius: radius.md,
    backgroundColor: colors.surface,
    border: `1px solid ${colors.accentMuted}`,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.lg,
    },
  },
  summaryMain: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
    flex: 1,
    minWidth: 0,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  photoWrapper: {
    flexShrink: 0,
    width: sizes.profilePhotoSize,
    height: sizes.profilePhotoSize,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: 140,
      height: 140,
    },
  },
  summaryInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    minWidth: 0,
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      alignItems: 'flex-start',
    },
  },
  userName: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: 48,
    color: colors.textBody,
    lineHeight: 'normal',
    wordBreak: 'break-word',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.xl,
      textAlign: 'center',
    },
  },
  metaRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 40,
    alignItems: 'center',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      justifyContent: 'center',
      gap: spacing.sm,
    },
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.textBody,
    minWidth: 0,
  },
  metaIcon: {
    fontSize: 20,
    color: colors.textBody,
    flexShrink: 0,
  },
  outlineButton: {
    ...secondaryButtonStyle,
    flexShrink: 0,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: '100%',
      padding: `0 ${spacing.xs}px`,
      fontSize: fontSize.sm,
      letterSpacing: 0,
      justifyContent: 'center',
      '& .MuiButton-label': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        whiteSpace: 'nowrap',
      },
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 0,
        flexShrink: 0,
      },
    },
  },
  outlineButtonIcon: {
    fontSize: 16,
    marginRight: spacing.xs,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      marginRight: 0,
      fontSize: 14,
    },
  },
  outlineButtonText: {
    whiteSpace: 'nowrap',
  },
}));
